import { withInstall, withNoopInstall } from "@xplus/utils/with-install";
import checkbox from "./src/checkbox.vue";
import checkboxGroup from "./src/checkbox-group.vue";
export const xCheckbox = withInstall(checkbox, { checkboxGroup });
export const xCheckboxGroup = withNoopInstall(checkboxGroup);
export default xCheckbox;
